// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"70425e95","419":"a2472562","707":"a932467e","992":"9fa6e77a"}[chunkId] + ".chunk.css";
};